export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YOZqilUs6yLUrwB0lw.37483447.woff2";